// extracted by mini-css-extract-plugin
export default {"adminContainer":"admin_adminContainer__RYojs","buttons":"admin_buttons__Ho3LD","icon":"admin_icon__fa0Ey","arrow":"admin_arrow__zR+92"};